import { useCmsContentStructureQuery } from 'api/cmsContent/cmsContent';
import { REACT_APP_MAIN_SITE_HOMEPAGE } from 'config';
import { SupportedLanguageCode } from 'i18n/i18n.types';
import { useTranslation } from 'react-i18next';

export const getCmsContent = (i18nCode?: SupportedLanguageCode) => {
  const {
    i18n: { language },
  } = useTranslation();

  const languageCode = i18nCode ?? (language as SupportedLanguageCode);

  return useCmsContentStructureQuery(languageCode);
};

export const buildContentImageLink = (imageLink: string) => {
  const fullLink = REACT_APP_MAIN_SITE_HOMEPAGE + imageLink;
  return fullLink;
};
